import { baseUrl } from "../../../config.js";
import { setDocTitle } from "../../../functions/HelperFuncs.js";
import i18n from "../../../functions/i18next.js";

export default {
  data() {
    return {
      user: this.$store.state.user,
      company: this.$store.state.company,
      company_full: null,
      originalPlan: null,
      confirmText: "",
      error: "",
    };
  },
  created() {
    setDocTitle("plan", this);

    this.$axios
      .get(baseUrl + "/company?company=" + this.company, {
        responseType: "json",
      })
      .then((response) => {
        this.company_full = response.data;
        this.originalPlan = this.company_full.plan.name;
        if (this.company_full.trialing) {
          this.confirmText = i18n.t("plan.continue_to_payment");
        }
      })
      .catch((e) => {});
  },
  methods: {
    changePlan(to) {
      this.error = "";
      this.company_full.plan.name = to;
      if (!this.company_full.subscribed) {
        this.confirmText = i18n.t("plan.continue_to_payment");
        return;
      }
      if (this.company_full.plan.name != this.originalPlan) {
        this.confirmText = i18n.t("common.confirm");
      } else {
        this.confirmText = "";
      }
    },
    confirm() {
      if (!this.company_full.subscribed) {
        let data = new FormData();
        data.append("plan", this.company_full.plan.name);
        this.$axios
          .post(baseUrl + "/subscription/create", data)
          .then((response) => {
            if (response.data.message == "Redirect") {
              window.location = response.data.url;
            } else {
              this.$router.push("/" + this.company_full.name + "/billing");
            }
          })
          .catch((response) => {
            console.error("Error");
          });
        return;
      }
      if (this.company_full.plan.name != this.originalPlan) {
        this.error = "";
        this.$axios
          .put(
            baseUrl + "/subscription/change?plan=" + this.company_full.plan.name
          )
          .then((response) => {
            if (response.data.message == "OK") {
              this.$router.push(
                "/" +
                  this.company_full.name +
                  "/billing?status=" +
                  response.data.when
              );
            }
            if (response.data.message == "ERROR") {
              this.error = response.data.error;
            }
          })
          .catch((response) => {
            console.error("Error");
          });
      }
    },
  },
};
